/*
 comments and posts api
*/

import axios from "../axios/axios";

export function getPostsApi(params) {
  return axios.post('/content/posts', params);
}

export function getStopPostsApi(params) {
  return axios.post('/thread/listStopPost', params);
}

export function setPostsTrustApi(params) {
  return axios.post('/content/setposttrust', params);
}

export function getPostsCommentsApi(params) {
  return axios.post('/content/commentaries', params);
}

export function setCommentTrustApi(params) {
  return axios.post('/content/setcommenttrust', params);
}

export function addToAllPosts(params) {
  return axios.post('/thread/removestoppost', params);
}

export function addToStopPosts(params) {
  return axios.post('/thread/addstoppost', params);
}

export function addPost(params) {
  return axios.post('/thread/addpost', params);
}

export function getAllComments(params) {
  return axios.post('/content/allcommentaries', params);
}

export function getPostInfoApi(params) {
  return axios.post('/content/postinfo', params);
}

export function getPostAtTendance(params) {
  return axios.post('/stats/getpostattendance', params);
}

export function getPostSiblings(params) {
  return axios.post('/stats/getpostsiblings', params);
}

export function getChildComments(params) {
  return axios.post('/content/childcommentaries', params);
}
